export const DATASET = {
  PHARMACY: 'pharmacy',
  SERVICE: 'service',
  OPENING_HOURS: 'opening_hours',
  ALL: 'all',
} as const
export type Dataset = (typeof DATASET)[keyof typeof DATASET]
